import { useState, useEffect } from 'react'
import { Grid } from './components/grid/Grid'
import { Keyboard } from './components/keyboard/Keyboard'
import { InfoModal } from './components/modals/InfoModal'
import { StatsModal } from './components/modals/StatsModal'
import { SettingsModal } from './components/modals/SettingsModal'
import { ArenaHelper } from './lib/ArenaHelper'
import { useWindowSize } from './hooks/useWindowSize'
import {
  WIN_MESSAGES,
  GAME_COPIED_MESSAGE,
  NOT_ENOUGH_LETTERS_MESSAGE,
  WORD_NOT_FOUND_MESSAGE,
  CORRECT_WORD_MESSAGE,
  HARD_MODE_ALERT_MESSAGE
} from './constants/strings'
import {
  MAX_WORD_LENGTH,
  MAX_CHALLENGES,
  ALERT_TIME_MS,
  REVEAL_TIME_MS,
  GAME_LOST_INFO_DELAY,
} from './constants/settings'
import {
  isWordInWordList,
  isWinningWord,
  getWordsOfDay,
  findFirstUnusedReveal,
} from './lib/words'
import {
  addFinalStatsForCompletedGame,
  addHurdleStatsForCompletedGame,
  defaultStats,
  loadFinalStats,
  loadHurdleStats,
} from './lib/stats'
import {
  loadGameStateFromLocalStorage,
  setStoredIsHighContrastMode,
  getStoredIsHighContrastMode,
  setStoredIsHardMode,
  getStoredIsHardMode,
  saveGameStateToLocalStorage,
  saveGameStatusToLocalStorage,
  loadGameStatusFromLocalStorage,
  saveGameWonToLocalStorage,
  loadGameWonFromLocalStorage,
  loadHurdleStatsFromLocalStorage,
  saveGameLostToLocalStorage,
  loadGameLostFromLocalStorage,
  loadGameStartedFromLocalStorage,
  saveGameStartedToLocalStorage,
  loadGameScoreFromLocalStorage,
  saveFinalWonToLocalStorage,
  loadFinalWonFromLocalStorage,
  saveFinalScoreToLocalStorage,
  getFinalScoreFromLocalStorage,
  setStoredHurdleIndex,
} from './lib/localStorage'

import './App.css'
import { AlertContainer } from './components/alerts/AlertContainer'
import { useAlert } from './context/AlertContext'
import { generateStatus } from './lib/share'
import { Navbar } from './components/navbar/Navbar'

function App() {
  useWindowSize()

  const { showError: showErrorAlert, showSuccess: showSuccessAlert } =
    useAlert()
  const [currentGuess, setCurrentGuess] = useState('')
  const [isGameWon, setIsGameWon] = useState(false)
  const [reset, setReset] = useState(false)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false)
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false)
  const [currentRowClass, setCurrentRowClass] = useState('')
  const [isGameLost, setIsGameLost] = useState(false)

  const [solution, setSolution] = useState('');
  const [solution2, setSolution2] = useState("");
  const [solution3, setSolution3] = useState("");
  const [solution4, setSolution4] = useState("");
  const [solution5, setSolution5] = useState("");
  const [solutionIndex, setSolutionIndex] = useState("");
  const [words, setWords] = useState("");
  const [tomorrow, setTomorrow] = useState(0);


  useEffect(() => {
    (async () => {
      const words = await getWordsOfDay();
    // console.log("words", words);
      setSolution(words.solution);
      setSolution2(words.solution2);
      setSolution3(words.solution3);
      setSolution4(words.solution4);
      setSolution5(words.solution5);
      setSolutionIndex(words.solutionIndex);

      setWords(words);
      setTomorrow(words.tomorrow);
    })();
  },[])


  const [isDarkMode] = useState(true)
  const [isHighContrastMode, setIsHighContrastMode] = useState(
    getStoredIsHighContrastMode()
  )
  const [isRevealing, setIsRevealing] = useState(false)
  const [isLastStepRevealing, setIsLastStepRevealing] = useState(false)
  const [currentStatus, setCurrentStatus] = useState('');
  const [arenaHelper] = useState(() => new ArenaHelper())

  useEffect(() => {
    try {
      console.log("arenaHelper.initTestingEnvironment()")
      arenaHelper.initTestingEnvironment()
    } catch (e) {
      console.log("error on initTestingEnvironment", e);
    }
    
    if (loadGameWonFromLocalStorage() || loadGameLostFromLocalStorage()) {
      setIsStatsModalOpen(true)
    }

    const loaded = loadGameStateFromLocalStorage()
    if (loaded?.guesses) {
      try {
        setCurrentStep(Number(loaded?.currentStep))
        setGuesses(loaded.guesses)
      } catch (e) {}
    }
  }, [arenaHelper])

  const [guesses, setGuesses] = useState<string[]>(() => {
    let _solution = ''
    let _currentStep
    if (!_currentStep) {
      _currentStep = 1
    } else {
      _currentStep = currentStep
    }
    switch (_currentStep) {
      case 1:
        _solution = solution
        break
      case 2:
        _solution = solution2
        break
      case 3:
        _solution = solution3
        break
      case 4:
        _solution = solution4
        break
      case 5:
        _solution = solution5
        break
    }

    const loaded = loadGameStateFromLocalStorage()
    if (loaded?._solution !== _solution) {
      return []
    }

    const gameWasWon = loaded.guesses.includes(_solution)
    if (gameWasWon) {
      setIsGameWon(true)
    }
    if (loaded.guesses.length === MAX_CHALLENGES && !gameWasWon) {
      setIsGameLost(true)
      saveGameLostToLocalStorage(true)
      showErrorAlert(CORRECT_WORD_MESSAGE(_solution), {
        persist: true,
      })
    }
    return loaded.guesses
  })

  const [finalStats, setFinalStats] = useState('')
  const [hurdleStats, setHurldeStats] = useState(defaultStats)

  useEffect(() => {
    setFinalStats(JSON.stringify(loadFinalStats()))
    setHurldeStats(Object.assign({}, loadHurdleStats()))
  }, [])

  const [isHardMode, setIsHardMode] = useState(
     getStoredIsHardMode()
  )
  const [currentStep, setCurrentStep] = useState(1)
  const [slideOutAnimation, setSlideOutAnimation] = useState(false)
  const [slideInAnimation, setSlideInAnimation] = useState(false)
  const [finalWon, setFinalWon] = useState(false)
  const [totalStatus, setTotalStatus] = useState("")

  const [isLastStep, setIsLastStep] = useState(false)

  useEffect(() => {
    window.hurdle_score = 0;
    // if no game state on load,
    // show the user the how-to info modal
    if (!loadHurdleStatsFromLocalStorage()) {
      setIsInfoModalOpen(true)
    }
  }, [])

  useEffect(() => {
    if (true) {
      //isDarkMode
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }

    if (isHighContrastMode) {
      document.documentElement.classList.add('high-contrast')
    } else {
      document.documentElement.classList.remove('high-contrast')
    }
  }, [isDarkMode, isHighContrastMode])

  const closeStatsModal = () => {
    if (
        loadGameLostFromLocalStorage() ||
        loadGameWonFromLocalStorage()
      )
     {
      if (loadFinalWonFromLocalStorage()) {
        try {
          console.log("arenaHelper.handleGameEnd(loadGameScoreFromLocalStorage(), 'Win')")
          arenaHelper.handleGameEnd(loadGameScoreFromLocalStorage(), 'Win');
        } catch (e) {
          console.log("error on handleGameEnd", e);
        }
      }

      if (loadGameLostFromLocalStorage()) {
        try {
          console.log("arenaHelper.handleGameEnd(loadGameScoreFromLocalStorage(), 'Lose')")
          arenaHelper.handleGameEnd(loadGameScoreFromLocalStorage(), 'Lose')
        } catch (e) {
          console.log("error on handleGameEnd", e);
        }
      }
    } else if (!loadGameStatusFromLocalStorage() && (isGameLost || isGameWon || finalWon)) { //localstorage is not available
      if (finalWon) {
        try {
          console.log("arenaHelper.handleGameEnd(window.hurdle_score, 'Win')")
          arenaHelper.handleGameEnd(window.hurdle_score, 'Win')
        } catch(e) {
          console.log("error on handleGameEnd", e);
        }
        
      } else {
        try {
          console.log("arenaHelper.handleGameEnd(window.hurdle_score, 'Lose')")
          arenaHelper.handleGameEnd(window.hurdle_score, 'Lose')
        } catch(e) {
          console.log("error on handleGameEnd", e);
        }
      }
    }

    setIsStatsModalOpen(false)
  }

  const handleHardMode = (isHard: boolean) => {
    if (guesses.length === 0 || getStoredIsHardMode()) {
      setIsHardMode(isHard)
      setStoredIsHardMode(isHard ? 'hard' : 'normal')
    } else {
      showErrorAlert(HARD_MODE_ALERT_MESSAGE)
    }
  }


  const handleHighContrastMode = (isHighContrast: boolean) => {
    setIsHighContrastMode(isHighContrast)
    setStoredIsHighContrastMode(isHighContrast)
  }

  useEffect(() => {
    if (isGameLost && currentStep !== 5) {
      const statusFromLocalStorage = loadGameStatusFromLocalStorage()
      let _currentStatus = ''
      if (statusFromLocalStorage) {
        _currentStatus = statusFromLocalStorage
      }
     

      if (!getFinalScoreFromLocalStorage()) {
        saveGameStatusToLocalStorage(
          _currentStatus +
            generateStatus(guesses, isGameLost, isHardMode, currentStep, false, words)
        )
        setTotalStatus(totalStatus + 
          generateStatus(guesses, isGameLost, isHardMode, currentStep, false, words)) 
  
          saveFinalScoreToLocalStorage(true)  
      }
    
    }
  }, [guesses, currentStep, isGameLost, isGameWon])

  useEffect(() => {
    if (isGameWon) {
      const winMessage =
        WIN_MESSAGES[Math.floor(Math.random() * WIN_MESSAGES.length)]
      const delayMs = REVEAL_TIME_MS * MAX_WORD_LENGTH

      if (currentStep === 5) {
        showSuccessAlert(winMessage, {
          delayMs,
          onClose: () => setIsStatsModalOpen(true),
        })
      }

      //Start new game
      setTimeout(() => {
        if (currentStep === 5) {
          const statusFromLocalStorage = loadGameStatusFromLocalStorage()
          let _currentStatus = ''
          if (statusFromLocalStorage) {
            _currentStatus = statusFromLocalStorage
          }
          let auxStatus =
            _currentStatus +
            generateStatus(guesses, false, isHardMode, currentStep, true, words)
          setCurrentStatus(auxStatus)
          saveGameStatusToLocalStorage(auxStatus)
          setTotalStatus(totalStatus + auxStatus)

        
        } else {
          const statusFromLocalStorage = loadGameStatusFromLocalStorage()
          let _currentStatus = ''
          if (statusFromLocalStorage) {
            _currentStatus = statusFromLocalStorage
          }

          let auxStatus =
            _currentStatus +
            generateStatus(guesses, false, isHardMode, currentStep, false, words)
          setCurrentStatus(auxStatus)
          saveGameStatusToLocalStorage(auxStatus)
          setTotalStatus(totalStatus + auxStatus)
        }

        setIsGameWon(false)
        onNextStep()
      }, 3000)
    }

    if (isGameLost) {
      setTimeout(() => {
        setIsStatsModalOpen(true)
      }, GAME_LOST_INFO_DELAY)
    }

    if (isGameLost && currentStep === 5) {
      const statusFromLocalStorage = loadGameStatusFromLocalStorage()
      let _currentStatus = ''
      if (statusFromLocalStorage) {
        _currentStatus = statusFromLocalStorage
      }

      let auxStatus =
        _currentStatus + generateStatus(guesses, true, isHardMode, currentStep, true, words)
      setCurrentStatus(auxStatus)
      saveGameStatusToLocalStorage(auxStatus)
      setTotalStatus(totalStatus + auxStatus)
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGameWon, isGameLost, showSuccessAlert, currentStep])

  const onChar = (value: string) => {
    if (loadGameWonFromLocalStorage()) {
      return
    }

    if (!loadGameStartedFromLocalStorage()) {
      try {
        console.log("arenaHelper.handleGameStart()");
        arenaHelper.handleGameStart()
      } catch(e) {
        console.log("error on handlegamestart", e);
      }
      
      saveGameStartedToLocalStorage(true)
      setStoredHurdleIndex(solutionIndex);
    }
    
    if (
      currentGuess.length < MAX_WORD_LENGTH &&
      guesses.length < MAX_CHALLENGES &&
      !isGameWon
    ) {
      setCurrentGuess(`${currentGuess}${value}`)
    }
  }

  const onNextStep = () => {
    if (isGameWon && currentStep < 5) {
      setSlideOutAnimation(true)
      setTimeout(() => {
        setGuesses([])
        setCurrentGuess('')
        setReset(true)
        setCurrentStep(currentStep + 1)

        try {
          console.log("arenaHelper.handleEventChange()");
          arenaHelper.handleEventChange()
        } catch(e) {
          console.log("error on handleEventChange", e);
        }
       

        setTimeout(() => {
          setSlideOutAnimation(false)
          setSlideInAnimation(true)
        }, 100)
        setSlideInAnimation(false)
      }, 500)
    }

    if (currentStep === 1) {
      setGuesses([])
      setTimeout(() => {
        setIsLastStep(true)
        setGuesses([solution])
        saveGameStateToLocalStorage({
          currentStep: 2,
          guesses: [solution],
          _solution: '',
          date: new Date().toUTCString(),
        })
        setTimeout(() => {
          setIsRevealing(true)
          setIsLastStep(false)
          setTimeout(() => {
            setIsRevealing(false)
          }, 2000)
        }, 500)
      }, 1000)
    }

    if (currentStep === 2) {
      setGuesses([])
      setTimeout(() => {
        setIsLastStep(true)
        setGuesses([solution2])
        saveGameStateToLocalStorage({
          currentStep: 3,
          guesses: [solution2],
          _solution: '',
          date: new Date().toUTCString(),
        })
        setTimeout(() => {
          setIsRevealing(true)
          setIsLastStep(false)
          setTimeout(() => {
            setIsRevealing(false)
          }, 2000)
        }, 500)
      }, 1000)
    }

    if (currentStep === 3) {
      setGuesses([])
      setTimeout(() => {
        setIsLastStep(true)
        setGuesses([solution3])
        saveGameStateToLocalStorage({
          currentStep: 4,
          guesses: [solution3],
          _solution: '',
          date: new Date().toUTCString(),
        })
        setTimeout(() => {
          setIsRevealing(true)
          setIsLastStep(false)
          setTimeout(() => {
            setIsRevealing(false)
          }, 2000)
        }, 500)
      }, 1000)
    }


    if (currentStep === 4) {
      setGuesses([])
      setTimeout(() => {
        setIsLastStep(true)
        setGuesses([solution, solution2, solution3, solution4])
        saveGameStateToLocalStorage({
          currentStep: 5,
          guesses: [solution, solution2, solution3, solution4],
          _solution: '',
          date: new Date().toUTCString(),
        })
        setTimeout(() => {
          setIsRevealing(true)
          setIsLastStepRevealing(true)
          setIsLastStep(false)
          setTimeout(() => {
            setIsRevealing(false)
          }, 2000)
        }, 500)
      }, 1000)
    }
  }

  const onDelete = () => {
    setCurrentGuess(currentGuess.slice(0, -1))
  }

  const onEnter = () => {
    if (
      isGameWon ||
      isGameLost ||
      loadGameWonFromLocalStorage() ||
      loadGameLostFromLocalStorage()
    ) {
      return
    }

    let _solution = ''
    switch (currentStep) {
      case 1:
        _solution = solution
        break
      case 2:
        _solution = solution2
        break
      case 3:
        _solution = solution3
        break
      case 4:
        _solution = solution4
        break
      case 5:
        _solution = solution5
        break
    }

    if (!(currentGuess.length === MAX_WORD_LENGTH)) {
      showErrorAlert(NOT_ENOUGH_LETTERS_MESSAGE)
      setCurrentRowClass('jiggle')
      return setTimeout(() => {
        setCurrentRowClass('')
      }, ALERT_TIME_MS)
    }

    if (!isWordInWordList(currentGuess)) {
      showErrorAlert(WORD_NOT_FOUND_MESSAGE)
      setCurrentRowClass('jiggle')
      return setTimeout(() => {
        setCurrentRowClass('')
      }, ALERT_TIME_MS)
    }

    // enforce hard mode - all guesses must contain all previously revealed letters
    if (isHardMode) {
      const firstMissingReveal = findFirstUnusedReveal(
        words,
        currentGuess,
        guesses,
        currentStep
      )
      if (firstMissingReveal) {
        showErrorAlert(firstMissingReveal)
        setCurrentRowClass('jiggle')
        return setTimeout(() => {
          setCurrentRowClass('')
        }, ALERT_TIME_MS)
      }
    }

    setIsRevealing(true)
    // turn this back off after all
    // chars have been revealed
    setTimeout(() => {
      setIsRevealing(false)
    }, REVEAL_TIME_MS * MAX_WORD_LENGTH)

    const winningWord = isWinningWord(words, currentGuess, currentStep)

    if (
      currentGuess.length === MAX_WORD_LENGTH &&
      guesses.length < MAX_CHALLENGES &&
      !isGameWon
    ) {
      setGuesses([...guesses, currentGuess])
      setCurrentGuess('')

      if (winningWord) {
        if (currentStep === 5) {
          setFinalWon(true)
          saveFinalWonToLocalStorage(true);
          try {
            console.log("arenaHelper.handleEventChange()");
            arenaHelper.handleEventChange()
          } catch(e) {
            console.log("error on handleEventChange", e);
          }
          saveGameWonToLocalStorage(true)
          setFinalStats(
            JSON.stringify(
              addFinalStatsForCompletedGame(finalStats, guesses.length, currentStep)
            )
          )
        } else {
          setHurldeStats(
            addHurdleStatsForCompletedGame(hurdleStats, guesses.length)
          )
        }

        if (currentStep < 5) {
          let _currentStep = winningWord ? currentStep + 1 : currentStep
          saveGameStateToLocalStorage({
            currentStep: _currentStep,
            guesses: [],
            _solution,
            date: new Date().toUTCString(),
          })
        } else {
          let _guesses: string[] = [...guesses, currentGuess]
          saveGameStateToLocalStorage({
            currentStep,
            guesses: _guesses,
            _solution,
            date: new Date().toUTCString(),
          })
        }

        return setIsGameWon(true)
      }

      if (guesses.length === MAX_CHALLENGES - 1) {
         if (currentStep !== 5) {
          setHurldeStats(
            addHurdleStatsForCompletedGame(hurdleStats, guesses.length + 1)
          )
        } 
        setFinalStats(
          JSON.stringify(
            addFinalStatsForCompletedGame(finalStats, guesses.length + 1, currentStep)
          )
        )
        setIsGameLost(true)
        saveGameLostToLocalStorage(true)

        showErrorAlert(CORRECT_WORD_MESSAGE(_solution), {
          persist: true,
          delayMs: REVEAL_TIME_MS * MAX_WORD_LENGTH + 1,
        })
      }
    }

    let _currentStep = winningWord ? currentStep + 1 : currentStep
    let _guesses: string[] = [...guesses, currentGuess]
    saveGameStateToLocalStorage({
      currentStep: _currentStep,
      guesses: _guesses,
      _solution,
      date: new Date().toUTCString(),
    })
  }

  return (
    <div className="h-screen flex flex-col">
      <Navbar
        setIsInfoModalOpen={setIsInfoModalOpen}
        setIsStatsModalOpen={setIsStatsModalOpen}
        setIsSettingsModalOpen={setIsSettingsModalOpen}
        currentStep={currentStep}
      />
      <div className="pt-2 px-1 pb-8 md:max-w-7xl w-full mx-auto sm:px-6 lg:px-8 flex flex-col grow">
        <div className="pb-6 grow board-container">
          <Grid
            currentStep={currentStep}
            guesses={guesses}
            currentGuess={currentGuess}
            isRevealing={isRevealing}
            currentRowClassName={currentRowClass}
            reset={reset}
            slideOutAnimation={slideOutAnimation}
            slideInAnimation={slideInAnimation}
            lastStep={isLastStep}
            isLastStepRevealing={isLastStepRevealing}
            finalWon={finalWon}
            isHighContrast={isHighContrastMode}
            words={words}
          />
        </div>
        <Keyboard
          currentStep={currentStep}
          onChar={onChar}
          onDelete={onDelete}
          onEnter={onEnter}
          guesses={guesses}
          isRevealing={isRevealing}
          isHighContrast={isHighContrastMode}
          words={words}
        />
        <InfoModal
          isOpen={isInfoModalOpen}
          handleClose={() => setIsInfoModalOpen(false)}
          isHighContrast={isHighContrastMode}
        />
        {finalStats !== '' && (
          <StatsModal
            currentStep={currentStep}
            isOpen={isStatsModalOpen}
            handleClose={closeStatsModal}
            guesses={guesses}
            currentStatus={currentStatus}
            totalStatus={totalStatus}
            finalGameStats={finalStats}
            hurdleGameStats={hurdleStats}
            isGameLost={isGameLost}
            isGameWon={isGameWon}
            handleShare={() => showSuccessAlert(GAME_COPIED_MESSAGE)}
            isHardMode={isHardMode}
            finalWon={finalWon}
            words={words}
            tomorrow={tomorrow}
            solutionIndex={solutionIndex}
          />
        )}

        <SettingsModal
          isOpen={isSettingsModalOpen}
          handleClose={() => setIsSettingsModalOpen(false)}
          isHardMode={isHardMode}
          isHighContrastMode={isHighContrastMode}
          handleHighContrastMode={handleHighContrastMode}
          handleHardMode={handleHardMode}
        />
        <AlertContainer />
      </div>
    </div>
  )
}

export default App
